import { render } from "./patient_biodata.vue?vue&type=template&id=c94abe42&scoped=true"
import script from "./patient_biodata.vue?vue&type=script&lang=js"
export * from "./patient_biodata.vue?vue&type=script&lang=js"

import "./patient_biodata.vue?vue&type=style&index=0&id=c94abe42&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94abe42"]])

export default __exports__